const UNCLOSED_MIX_TAG_TOKEN = '__TAGIFY_UNCLOSED_OPEN_BRACES__';
const COMPLETE_MIX_TAG_REGEX = /\{\{[\s\S]*?\}\}/g;

export function prepareUnclosedMixTagOpeners(value) {
  if (!value || !value.includes('{{')) {
    return { value, token: null };
  }

  const textSegments = value.split(COMPLETE_MIX_TAG_REGEX);
  const completeTags = value.match(COMPLETE_MIX_TAG_REGEX) || [];
  let hasReplacement = false;
  const rebuilt = [];

  textSegments.forEach((segment, index) => {
    const normalizedSegment = segment.replace(/\{\{/g, () => {
      hasReplacement = true;
      return UNCLOSED_MIX_TAG_TOKEN;
    });
    rebuilt.push(normalizedSegment);

    if (index < completeTags.length) {
      rebuilt.push(completeTags[index]);
    }
  });

  if (!hasReplacement) {
    return { value, token: null };
  }

  return { value: rebuilt.join(''), token: UNCLOSED_MIX_TAG_TOKEN };
}

export function restoreUnclosedMixTagOpeners(tagifyInstance, token) {
  if (!token || !tagifyInstance?.DOM?.input) {
    return;
  }

  const walker = document.createTreeWalker(tagifyInstance.DOM.input, NodeFilter.SHOW_TEXT);
  let currentNode = walker.nextNode();

  while (currentNode) {
    if (currentNode.textContent?.includes(token)) {
      currentNode.textContent = currentNode.textContent.replaceAll(token, '{{');
    }
    currentNode = walker.nextNode();
  }
}
